import { useState } from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink, Outlet, useParams, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { loggedUser } from '../../../../store/features/authSlice';
import { useSelector } from 'react-redux';

const UserNavigation = (props) => {
  let { id } = useParams();
  const location = useLocation();
  const { t, routeName } = props;
  const currentURL = location.pathname;
  const [userDataFromChildData, setUserDataFromChildData] = useState(null);
  const checkLoggedInUser = useSelector(loggedUser);
  const loggedInUserId = checkLoggedInUser?.user?.user_id;
  const isAdmin = checkLoggedInUser?.user?.user_type == 1; 
  const isApprover =
    userDataFromChildData?.userScoreByAccess?.some(
      (item) => item.approver_id == loggedInUserId
    );
  const navigateArray = [
    {
      label: t('page.add_user_general_details_title'),
      link: `/user/view/details/${id}`,
      identity: 'details',
      permission: 'user.index'
    }]
    if (userDataFromChildData?.user_type === 2) {
        navigateArray.push(
            {
                label: t('page.add_user_address_details_title'),
                link: `/user/view/${id}/address`,
                identity: 'address',
                permission: 'user.address.index'
            },
            {
                label: t('page.add_user_contact_and_additional_title'),
                link: `/user/view/${id}/contact`,
                identity: 'contact',
                permission: 'user.contact.index'
            },
            {
                label: t('page.add_department_and_designation_title'),
                link: `/user/view/${id}/designation-department`,
                identity: 'designation-department',
                permission: 'user.department.and.designation.index'
            },
            {
                label: t('page.add_user_approvers_title'),
                link: `/user/view/${id}/approvers`,
                identity: 'approvers',
                permission: 'user.approver.index'
            },
             ...(isApprover || isAdmin
              ? [{
                  label: t('page.add_user_skills_title'),
                  link: `/user/view/${id}/user-skills-score`,
                  identity: 'user-skills-score',
                  permission: 'user.index'
                }]
              : []
            ),
            {
                label: t('page.add_user_other_title'),
                link: `/user/view/${id}/others`,
                identity: 'others',
                permission: 'user.others.index'
            })
    }else{
        navigateArray.push({
                label: t('page.add_user_contact_and_additional_title'),
                link: `/user/view/${id}/contact`,
                identity: 'contact',
                permission: 'user.contact.index'
        });
    }

  return (
    <>
      <div className="page-title d-flex align-items-start justify-content-between flex-wrap flex-column flex-md-row align-items-md-center">
        {/* Employee Name */}
        <div className="d-flex align-items-start gap-1 flex-wrap flex-column flex-md-row align-items-md-center gap-md-2">
          <h1 className="title">{userDataFromChildData?.name}</h1>

          {/* department or field */}
          <span className="status-label blue bordered mt-1 mt-md-0">
            <span className="me-2">•</span>
            {userDataFromChildData?.role_name}
          </span>
        </div>

        <div className="d-flex align-items-center gap-2 flex-wrap">
          {/* Joining Date */}
           {
            userDataFromChildData?.user_type == 2 && userDataFromChildData?.formatted_joining_date != '' && userDataFromChildData?.formatted_joining_date != null ?
            <span className="status-label blue bordered mt-0 mt-sm-3 mt-md-0">
            {t('page.header_join_title')} - {userDataFromChildData?.formatted_joining_date ?? ''}
          </span> : ''
          }



          {/* Left Date */}
          {
            userDataFromChildData?.user_type == 2 && userDataFromChildData?.formatted_last_working_date != '' && userDataFromChildData?.formatted_last_working_date != null ? <span className="status-label red bordered mt-0 mt-sm-3 mt-md-0">
            {t('page.header_left_title')} - {userDataFromChildData?.formatted_last_working_date}
          </span> : ''
          }

        </div>
      </div>
      <Nav className="custom-tabs mb-4">
        {navigateArray.map(
          (navigateObject, index) =>
            routeName.includes(navigateObject.permission) && (
              <Nav.Item key={index}>
                <NavLink
                  className={
                    !currentURL.includes(navigateObject.identity)
                      ? 'nav-link'
                      : 'active-tab nav-link'
                  }
                  to={navigateObject.link}>
                  {' '}
                  {navigateObject.label}{' '}
                </NavLink>
              </Nav.Item>
            )
        )}
      </Nav>
      <Outlet context={{ userDataFromChildData, setUserDataFromChildData }} />
    </>
  );
};
UserNavigation.propTypes = {
  t: PropTypes.func,
  id: PropTypes.string,
  routeName: PropTypes.array,
  activeLabel: PropTypes.string
};
export { UserNavigation };
